import React from "react";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";

interface ObjectiveCardProps {
  title: string;
  description: string;
  colorClass: string;
}

const ObjectiveCard = ({ title, description, colorClass }: ObjectiveCardProps) => {
  return (
    <Card className="overflow-hidden hover:shadow-lg transition-shadow duration-300">
      <CardContent className="p-6">
        <h3 className={`text-xl font-semibold mb-2 ${colorClass}`}>{title}</h3>
        <p className="text-gray-600 leading-relaxed">{description}</p>
      </CardContent>
    </Card>
  );
};

export default ObjectiveCard;